module.exports = __webpack_public_path__ + "img/special_arcade.0f60f5b8.png";